export const SUPERVISORS = "supervisors";
export const WAREHOUSE_KEEPERS = "warehouse-keepers";
export const SUPPORT_ENGINEERS = "support-engineers";
export const SERVICE_USERS = "service-users";
export const AUDITORS = "auditors";
export const ADMINS = "admins";
export const ANALYZERS = "analyzers";
